// src/config/apiConfig.js
const apiConfig = {
  baseURL: "https://wfksqdbjt0.execute-api.ap-southeast-2.amazonaws.com/dev", // 后端域名
  // baseURL: "http://localhost:3000",
  timeout: 100000, // 可选：请求超时时间（单位：毫秒）
};

export default apiConfig;